import { attr, belongsTo } from 'spraypaint';
import stringOrNullAttr from '../stringOrNullAttr';
import ApplicationRecord from './ApplicationRecord';

const GiftCard = ApplicationRecord.extend({
  attrs: {
    amount: attr({ type: Number }),
    code: belongsTo({ type: 'vouchers-codes', persist: false }),
    code_id: attr({ type: Number }),
    created_at: attr({ persist: false }),
    customer_id: attr({ type: Number }),
    delivery_type: attr(),
    expires_on: attr(),
    id: attr({ type: Number }),
    issued_at: attr(),
    personalised_message: attr(),
    promotion: belongsTo({ type: 'vouchers-promotions', persist: false }),
    promotion_id: attr({ type: Number, persist: false }),
    recipient_address_locality: stringOrNullAttr(),
    recipient_address_postcode: stringOrNullAttr(),
    recipient_address_street_1: stringOrNullAttr(),
    recipient_address_street_2: stringOrNullAttr(),
    recipient_email: stringOrNullAttr(),
    recipient_first_name: attr(),
    recipient_last_name: attr(),
    send_gift_card_to_recipient: attr({ type: Boolean }),
    sender_email: stringOrNullAttr(),
    sender_first_name: stringOrNullAttr(),
    sender_last_name: stringOrNullAttr(),
    updated_at: attr({ persist: false }),
    trigger_payment: attr({ type: Boolean }),
  },
  static: {
    endpoint: '/gift_cards',
    jsonapiType: 'vouchers-gift_cards',
  },
});

export default GiftCard;
